RESET_PAYMENT_ERROR